<template>
  <section class="opportunities">
    <div class="container">
      <h2 class="title">Наши услуги</h2>

      <!-- Карточки -->
      <div class="cards">
        <div class="card">
          <h3>Проверка</h3>
          <p>
            Работайте с надёжными и чистыми представителями бизнеса, проверяя
            контрагента по всем ключевым параметрам.
          </p>
        </div>
        <div class="card">
          <h3>Фильтрация</h3>
          <p>
            Поиск потенциальных клиентов при помощи фильтров. Например, можно
            найти компании без деятельности, с выручкой выше миллиона или с
            арбитражами.
          </p>
          <button class="btn">Сделать выгрузку</button>
        </div>
        <div class="card">
          <h3>API</h3>
          <p>
            Большое API для интеграции с внутренними системами. Можно
            автоматизировать проверку контрагентов и получать обновления по
            документам.
          </p>
        </div>
        <div class="card">
          <h3>Мониторинг</h3>
          <p>
            Автоматическое наблюдение за изменениями в компаниях. Будьте в курсе
            всех важных событий, касающихся ваших контрагентов, и принимайте
            решения оперативно.
          </p>
        </div>
        <div class="card">
          <h3>Выгрузка по ИНН</h3>
          <p>
            Узнайте всё необходимое о ваших бизнес-партнерах в один момент, без
            привлечения разработчиков и сложных интеграций. Загрузите перечень
            ИНН и получите файл с полной информацией.
          </p>
          <button class="btn">Сделать выгрузку</button>
        </div>
        <div class="card">
          <h3>Специальные реестры</h3>
          <p>
            Наличие компании в реестрах неблагонадежных или дисквалифицированных
            лиц, а также информация о недостоверных данных – сигнал о повышенных
            рисках. Требуется углубленная проверка.
          </p>
          <button class="btn">Сделать выгрузку</button>
        </div>
      </div>

      <!-- Теги -->
      <div class="tags">
        <span class="tag" v-for="tag in tags" :key="tag">{{ tag }}</span>
      </div>
    </div>
  </section>
</template>

<script setup>
const tags = [
  "Быстрая поддержка",
  "Экспресс-анализ надёжности",
  "История изменений",
  "Контакты",
  "Выписка из ЕГРЮЛ",
  "Новой поисковой движок",
  "Добавить контрагента в друзья",
  "Действующие лицензии",
  "Финансы и РНСМ",
  "Банкротства",
  "Связи и аффилированность",
  "Специальные реестры",
  "Отслеживание изменений",
  "Арбитражные дела",
];
</script>

<style scoped lang="scss">
.opportunities {
  padding: 60px 20px;
  background: rgba(245, 247, 250, 1);
  box-shadow: 0px 8px 24px 0px rgba(129, 135, 189, 0.15);
}
.container {
  max-width: 1200px;
  margin: 0 auto;
}
.title {
  font-size: 45px;
  font-weight: bold;
  margin-bottom: 40px;
  text-align: center;
  color: rgba(62, 62, 62, 1);

  @media (max-width: 768px) {
    font-size: 24px;
  }
}
.cards {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  justify-content: center;
  margin-bottom: 40px;
}
.card {
  background: #fff;
  padding: 32px;
  border-radius: 30px;
  border: none;
  flex: 1;
  min-width: 360px;
  max-width: 400px;
  box-shadow: 0px 8px 24px 0px rgba(129, 135, 189, 0.15);
  display: flex;
  flex-direction: column;
}
.card h3 {
  font-size: 22px;
  margin-bottom: 16px;
  color: rgba(62, 62, 62, 1);

  @media (max-width: 768px) {
    font-size: 18px;
  }
}
.card p {
  font-size: 18px;
  line-height: 1.4;
  color: rgba(62, 62, 62, 0.6);

  @media (max-width: 768px) {
    font-size: 14px;
  }
}
.card .btn {
  margin-top: auto;
  background-color: rgba(181, 219, 255, 1);
  color: rgba(0, 102, 206, 1);
  border: none;
  border-radius: 100px;
  padding: 8px 16px;
  font-size: 18px;
  cursor: pointer;
  align-self: flex-end;

  @media (max-width: 768px) {
    font-size: 14px;
  }
}
.tags {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
}
.tag {
  background: rgba(0, 199, 130, 1);
  color: white;
  padding: 10px 14px;
  border-radius: 100px;
  font-size: 20px;
  white-space: nowrap;

  @media (max-width: 768px) {
    font-size: 14px;
  }
}
</style>
